// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color } from "@synd/XDL/Utilities";
import React from "react";
import styled, { css } from "styled-components";

const SkeletonBaseElement = styled.div`
    @keyframes shine {
        to {
            background-position-x: -200%;
        }
    }
    background: linear-gradient(
        110deg,
        ${color("common.ui2")} 8%,
        ${color("common.ui1")} 18%,
        ${color("common.ui2")} 33%
    );
    animation: shine 1s linear infinite;
    background-size: 200% 100%;
`;

export const SkeletonElement = styled(SkeletonBaseElement)<
    {
        height?: string;
        width?: string;
        borderRadius?: string;
        disabledAnimation?: boolean;
        margin?: string;
    } & InjectableCss
>`
    width: ${({ width }) => width || "100%"};
    min-height: ${({ height }) => height || "100%"};
    ${({ borderRadius }: any) => borderRadius && `border-radius: ${borderRadius};`}
    ${({ margin }: any) => margin && `margin: ${margin};`}
    
    ${({ disabledAnimation }: any) =>
        disabledAnimation &&
        css`
            animation: unset;
            background: unset;
        `}
    ${injectCss}
`;

interface OwnProps {
    width?: string;
    height?: string;
    isLoading?: boolean;
    borderRadius?: string;
    disabledAnimation?: boolean;
    margin?: string;
}

type Props = OwnProps & InjectableCss;

const Skeleton = ({ width, height, isLoading = true, css, borderRadius, disabledAnimation, margin }: Props) => {
    if (!isLoading && !disabledAnimation) {
        return null;
    }

    return (
        <SkeletonElement
            width={width}
            height={height}
            css={css}
            borderRadius={borderRadius}
            disabledAnimation={disabledAnimation}
            margin={margin}
        />
    );
};

export default Skeleton;
